module.exports = __webpack_public_path__ + "img/img2.dec76bc9.jpg";